import Image from 'next/image';
import ValidationMessage from '../PcModelValidationMessage';
import styles from './styles';

const ValidationAlert = ({ errors }) => (
  <>
    <div className="alert-box">
      {errors.map((error, index) => (
        <div className="alert-item" key={JSON.stringify(error)}>
          <div className="alert-image">
            <Image draggable={false}
              src="/icons/icon-exclamation.svg"
              alt="Error"
              width={16}
              height={16}
            />
          </div>
          <div className="alert-message">
            <ValidationMessage error={error} prevError={index !== 0 ? errors[index -1] : {}} />
          </div>
        </div>
      ))}
    </div>

    <style jsx>{styles}</style>
  </>
);

ValidationAlert.propTypes = {};

export default ValidationAlert;
